export default {
  methods: {
    pluralize(str, itemsLength) {
      return itemsLength > 1 ? `${str}s` : str;
    },

    lowerCaseNoSpace(str) {
      if (typeof str !== 'string') return str;
      return str.toLowerCase().replace(/\s+/g, '');
    },
  },
};
